import React from 'react';
import { useSchedulesQuery } from '../queries';

const FOOTBALL3D_SPORT_ID = 50;

/**
 * Returns the schedule_id for Football 3D (sport_id=50).
 * Used by Football 3D views so they never use another schedule (e.g. horses).
 */
export function useFootball3dScheduleId(): number | string | null {
  const { data: schedules = [] } = useSchedulesQuery();
  return React.useMemo(() => {
    const schedule = Array.isArray(schedules)
      ? schedules.find((s) => Number(s?.sport?.sport_id) === FOOTBALL3D_SPORT_ID)
      : null;
    return schedule?.schedule_id ?? null;
  }, [schedules]);
}
